module.exports = __webpack_public_path__ + "static/media/menu-mis-servicios.c8bb0b4f.svg";